import React, { useState, useEffect, useLayoutEffect } from 'react';
import { register } from '../../../i18n';
import LessonService from '../../services/LessonService';
import '../../../css/Tools.scss';
import '../../../css/Accessibility.scss';

const t = register('ToolNames');

const C2CTranslateLanguageSelector = ({
  activeTranslationId,
  isOpen,
  onSelect,
  onClose,
  positionStyle,
  onLayout,
}) => {
  const [languageNames, setLanguageNames] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const languages = await LessonService.fetchC2CTranslateLanguages();
        setLanguageNames(languages || {});
      } catch (error) {
        console.error('Error fetching C2C translate languages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLanguages();
  }, []);

  const languages = Object.keys(languageNames);

  useLayoutEffect(() => {
    if (!isOpen) return undefined;
    onLayout?.();
    const rafId = window.requestAnimationFrame(() => onLayout?.());
    return () => window.cancelAnimationFrame(rafId);
  }, [isOpen, loading, languages.length, positionStyle, onLayout]);

  if (!isOpen) return null;

  return (
    <div
      aria-labelledby='c2c-translate-dialog-title'
      className='dropdown-menu-popup open webreader-language-selector'
      role='menu'
      style={positionStyle}
    >
      <div className='selectorBody'>
        <h2 className='title-label basic webreader-language-title' id='c2c-translate-dialog-title'>
          {t('c2cTranslateSelectLanguage', 'Select C2C translation language')}
        </h2>
        {loading && (
          <div className='control-container webreader-language-list'>
            <span>{t('loadingLabel', 'Loading...')}</span>
          </div>
        )}
        {!loading && languages.length === 0 && (
          <div className='control-container webreader-language-list'>
            <span>{t('noLanguagesAvailable', 'No languages available')}</span>
          </div>
        )}
        {!loading && (
          <div className='control-container webreader-language-list'>
            <button
              key='default'
              className='tools-btn webreader-language-button'
              onClick={() => onSelect(null)}
              style={{ fontWeight: 'bold' }}
              type='button'
            >
              {!activeTranslationId && <span className='c2c-active-indicator'>&#10003;</span>}
              {t('c2cTranslateDefault', 'Default')}
            </button>
            {languages.map((lang) => {
              const entry = languageNames[lang];
              const displayName = entry?.name || lang;
              const verified = entry?.verified;
              const isActive = activeTranslationId === lang;
              return (
                <button
                  key={lang}
                  className='tools-btn webreader-language-button'
                  onClick={() => onSelect(lang)}
                  type='button'
                  style={verified ? { fontWeight: 'bold' } : undefined}
                >
                  {isActive && <span className='c2c-active-indicator'>&#10003;</span>}
                  {displayName}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default C2CTranslateLanguageSelector;
